var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.tab.length > 0 ? _c('div', {
    staticClass: "mTab"
  }, [_c('div', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll"
    }],
    staticClass: "mTab-scroll"
  }, [_c('div', {
    staticClass: "mTab-item-main"
  }, _vm._l(_vm.tab, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "mTab-item",
      class: {
        active: _vm.currentTab && _vm.currentTab.value === item.value
      },
      on: {
        "click": function ($event) {
          return _vm.onTab(item);
        }
      }
    }, [_c('div', {
      staticClass: "mTab-item__text"
    }, [_vm._v(" " + _vm._s(item.label) + " "), item.hasOwnProperty('tag') && item.tag ? _c('div', {
      staticClass: "mTab-item__tag"
    }, [_vm._v(_vm._s(item.tag))]) : _vm._e()])]);
  }), 0)])]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };